import React, { useState, useEffect } from 'react';
import { TextField, Button, Grid, MenuItem, Typography, Box } from '@mui/material';
import PropTypes from 'prop-types';

const FormPreInscricao = ({
  onSubmit,
  campanhas = [],
  cursos = [],
  periodos = [],
  disciplinas = [],
  classes = [],
  initialValues = {},
}) => {
  const [preInscricao, setPreInscricao] = useState({
    estudanteId: initialValues.estudanteId || '',
    campanhaId: initialValues.campanhaId || '',
    cursoId: '',
    classeId: '',
    periodoId: '',
    disciplinaId: '',
  });

  const [tipoInstituicao, setTipoInstituicao] = useState('');

  useEffect(() => {
    if (initialValues.campanhaId) {
      const campanhaSelecionada = campanhas.find(c => c.id === parseInt(initialValues.campanhaId));
      if (campanhaSelecionada) {
        setTipoInstituicao(campanhaSelecionada.tipoInstituicao);
      }
    }
  }, [initialValues.campanhaId, campanhas]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPreInscricao(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const preInscricaoData = { ...preInscricao };
    for (const key in preInscricaoData) {
      if (preInscricaoData[key] === '') {
        preInscricaoData[key] = null;
      }
    }
    onSubmit(preInscricaoData);
  };

  const renderCampos = () => {
    if (tipoInstituicao === 'Colégio') {
      return (
        <>
          <Grid item xs={12}>
            <TextField
              fullWidth
              select
              label="Período"
              name="periodoId"
              value={preInscricao.periodoId}
              onChange={handleChange}
              required
            >
              {periodos.map((periodo) => (
                <MenuItem key={periodo.id} value={periodo.id}>{periodo.nome}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              select
              label="Classe"
              name="classeId"
              value={preInscricao.classeId}
              onChange={handleChange}
              required
            >
             {classes.map((classe) => (
  <MenuItem key={classe.id} value={classe.id}>{classe.numero.toString()}</MenuItem>
))}

            </TextField>
          </Grid>
        </>
      );
    } else {
      return (
        <>
          <Grid item xs={12}>
            <TextField
              fullWidth
              select
              label="Curso"
              name="cursoId"
              value={preInscricao.cursoId}
              onChange={handleChange}
              required
            >
              {cursos.map((curso) => (
                <MenuItem key={curso.id} value={curso.id}>{curso.nome}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              select
              label="Período"
              name="periodoId"
              value={preInscricao.periodoId}
              onChange={handleChange}
              required
            >
              {periodos.map((periodo) => (
                <MenuItem key={periodo.id} value={periodo.id}>{periodo.nome}</MenuItem>
              ))}
            </TextField>
          </Grid>
          {tipoInstituicao !== 'Colégio' && (
            <Grid item xs={12}>
             
            </Grid>
          )}
        </>
      );
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
      <Typography variant="h6" gutterBottom>
        Nova Pré-Inscrição
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            select
            label="Campanha"
            name="campanhaId"
            value={preInscricao.campanhaId}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
          >
            {campanhas.map((campanha) => (
              <MenuItem key={campanha.id} value={campanha.id}>
                {campanha.nome}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        {renderCampos()}
        <Grid item xs={12}>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={
              !preInscricao.campanhaId ||
              (tipoInstituicao === 'Colégio' && (!preInscricao.periodoId || !preInscricao.classeId)) ||
              (tipoInstituicao !== 'Colégio' && (!preInscricao.cursoId || !preInscricao.periodoId))
            }
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

FormPreInscricao.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  campanhas: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    nome: PropTypes.string.isRequired,
    tipoInstituicao: PropTypes.string.isRequired,
  })),
  cursos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    nome: PropTypes.string.isRequired,
  })),
  periodos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    nome: PropTypes.string.isRequired,
  })),
  disciplinas: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    nome: PropTypes.string.isRequired,
  })),
  classes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    numero: PropTypes.string.isRequired,
  })),
  initialValues: PropTypes.object,
};

export default FormPreInscricao;
